// min and max inclusive
export function getRandomInteger(min, max) {
  min = Math.ceil(min); // just in case arguments are floats
  max = Math.floor(max);
  return Math.floor(Math.random() * (max + 1 - min) + min); // the + 1 is there to include max as possible result
}

export function getRandomItem(list) {
  return list[getRandomInteger(0, list.length - 1)];
}

export function getRandomSet(list, setSize) {
  const shuffledList = shuffleList(list);
  return shuffledList.slice(0, setSize);
}

export function shuffleList(list) {
  // Fisher Yates shuffle
  const shuffledList = [...list];
  for (let i = shuffledList.length - 1; i > 0; i--) {
    const j = getRandomInteger(0, i);
    [shuffledList[i], shuffledList[j]] = [shuffledList[j], shuffledList[i]];
  }
  return shuffledList;
}
